/* eslint-disable no-console */
import { Log as BBlog } from 'bblog';
import { type IkeClientService, Services } from './index';

export const LogStream = {
	LEVEL: BBlog.INFO,
	DELETE_KEYS: ['time', 'pid', 'msg', 'name', 'level', 'v', 'hostname'],
	setLevel(level) {
		LogStream.LEVEL = level;
	},
	write(msg) {
		if (LogStream.LEVEL > msg.level) {
			return;
		}
		var content = msg.msg;
		var output = {};
		Object.keys(msg).forEach((k) => {
			if (LogStream.DELETE_KEYS.indexOf(k) > -1) {
				return;
			}
			output[k] = msg[k];
		});

		if (Object.keys(output).length === 0) {
			output = '';
		}

		if (msg.level >= BBlog.WARN) {
			console.warn(content, output);
		} else if (msg.level >= BBlog.ERROR) {
			console.error(content, output);
		} else {
			console.log(content, output);
		}
	},
};

var logConfig = {
	name: 'DragonWeb',
	hostname: '?',
	streams: [LogStream],
};

export const Logger = BBlog.createLogger(logConfig);

export class LogService implements IkeClientService {
	__priority = 5;

	Logger = Logger;

	init() {
		const window = Services.Window.window;
		const hostname = window.location.hostname;
		Logger.addKeys({ hostname });

		if (hostname.indexOf('ikegps.com') > -1) {
			LogStream.setLevel(BBlog.ERROR);
		}
	}
}
